import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { SqButton } from "@/components/squircle-ui/button";
import { LuLoaderCircle } from "react-icons/lu";

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onStay: () => void;
  onDiscard: () => void;
  onAddAndContinue: () => void;
  isAdding?: boolean;
  title?: string;
  message?: React.ReactNode;
  stayButtonText?: string;
  discardButtonText?: string;
  addButtonText?: string;
};

const ConfirmationDialog: React.FC<Props> = ({
  isOpen,
  onOpenChange,
  onStay,
  onDiscard,
  onAddAndContinue,
  isAdding = false,
  title = "Finish adding selected brands",
  message = "",
  stayButtonText = "Stay",
  discardButtonText = "Discard",
  addButtonText = "Add & Continue",
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        className="squircle-mask squircle-radius-[12px] squircle-smooth-[1] border-none flex flex-col items-start gap-4 w-[512px] max-w-[512px] p-6"
      >
        <div className="flex flex-col gap-2">
          <h3 className="text-[16px] font-medium text-brand-primary-800 leading-[28px]">
            {title}
          </h3>
          <p className="text-[14px] text-brand-primary-600 leading-[20px]">{message}</p>
        </div>

        <div className="w-full flex items-center justify-between gap-3">
          <SqButton
            variant="outline"
            size="lg"
            onClick={onStay}
            className="px-[14px] font-medium text-[12px]"
          >
            {stayButtonText}
          </SqButton>
          <div className="flex gap-2">
            <SqButton
              variant="outline"
              size="lg"
              onClick={onDiscard}
              className="px-[14px] font-medium text-[12px]"
            >
              {discardButtonText}
            </SqButton>
            <SqButton
              variant="default"
              size="lg"
              onClick={onAddAndContinue}
              disabled={isAdding}
              className="px-4 font-medium text-[12px]"
            >
              {isAdding ? (
                <LuLoaderCircle className="animate-spin" size={16} />
              ) : (
                addButtonText
              )}
            </SqButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
